import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './menu-button.styles';
import Icon from '@material-ui/core/Icon';
import { infoToastAction } from 'utils';

const MenuButton = ({ title, icon, width, onClick, supervisorOnly = false, children }) => {
	const classes = useStyles();
    const globalDispatch = useDispatch();
    const { isSupervisor } = useSelector(globalState => globalState.user);

	const handleClick = () => {
		if (supervisorOnly && !isSupervisor) {
			globalDispatch(infoToastAction('You need to be a Supervisor to access this feature'));
		} else {
			onClick();
		}
	};

	return (
		<ButtonBase
			onClick={handleClick}
			focusRipple
			key={title}
			className={classes.image}
			focusVisibleClassName={classes.focusVisible}
			style={{
				width: width
			}}
		>
			<Icon component={icon} color="primary" style={{ fontSize: '200' }} />
			<span className={classes.imageBackdrop} />
			<span className={classes.imageButton}>
				<Typography component="span" variant="subtitle1" color="inherit" className={classes.imageTitle}>
					{title}
					{children}
				</Typography>
			</span>
		</ButtonBase>
	);
};

export default MenuButton;
